import Vue from "vue";
import Router from "vue-router";
import AppLayout from "bh-mod/layouts/App";
import Splash from "@/layouts/Splash";
import AuthLayout from 'bh-mod/layouts/Auth'
import store from "@/store";
import { VueAppMiddleware, setupEmailMonitoringApi } from "bh-mod";

Vue.use(Router);

const router = new Router({
	base: process.env.BASE_URL,
	mode: "history",
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		{
			path: "/",
			redirect: "/email",
			component: AppLayout,
			meta: {
				instanceRequired: true,
				auth: true,
				hidden: true,
			},
			children: [
				{
					path: "/email",
					meta: {
						title: "Email Broadcasts",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/email"),
				},
				{
					path: "/email/:id",
					meta: {
						title: "Email Details",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/email/details.vue"),
				},
				{
					path: "/sms",
					meta: {
						title: "SMS Broadcasts",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/sms"),
				},
				{
					path: "/sms/:id",
					meta: {
						title: "SMS Details",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/sms/details.vue"),
				},
				{
					path: "/survey/",
					meta: {
						title: "Form Surveys",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/survey"),
				},
				{
					path: "/survey/:id",
					meta: {
						title: "Survey Details",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/survey/details.vue"),
				},
				{
					path: "/agentCommission",
					meta: {
						title: "Agent Commission Report",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/agentCommission"),
				},
				{
					path: "/marketingWorkflow",
					meta: {
						title: "Marketing Workflow Report",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/marketingWorkflow"),
				},
				{
					path: "/marketingWorkflow/:id",
					meta: {
						title: "Marketing Workflow Details",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/marketingWorkflow/details.vue"),
				},
				{
					path: "/pipeline",
					meta: {
						title: "Pipeline Report",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/pipeline"),
				},
				{
					path: "/ai",
					meta: {
						title: "AI Report",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/ai"),
				},
				{
					path: "/lead",
					meta: {
						title: "Lead Report",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/lead"),
				},
				{
					path: "/lead/details",
					meta: {
						title: "Lead Details",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/lead/details.vue"),
				},
				{
					path: "/lead/campaignDetails",
					meta: {
						title: "Lead Campaign Details",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/lead/campaignDetails.vue"),
				},
				{
					path: "/pipeline/details",
					meta: {
						title: "Pipeline Details",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/pipeline/details.vue"),
				},
				{
					path: "/inventory",
					meta: {
						title: "Inventory Report",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/inventory"),
				},
				{
					path: "/inventory/details",
					meta: {
						title: "Inventory Details",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/inventory/details.vue"),
				},
				{
					path: "/sales",
					meta: {
						title: "Sales Reports",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/sales"),
				},
				{
					path: "/sales/details",
					meta: {
						title: "Sales Details",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/sales/details.vue"),
				},
				{
					path: "/deposits",
					meta: {
						title: "Deposit Report",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/deposit"),
				},
				{
					path: "/tasks",
					meta: {
						title: "Tasks Report",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/tasks"),
				},
				{
					path: "/tasks/details",
					meta: {
						title: "Tasks Details",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/tasks/details.vue"),
				},
				{
					path: "/website",
					meta: {
						title: "Website Reports",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/website"),
				},
				{
					path: "/website/details",
					meta: {
						title: "Website Details",
						dataRequired: true,
						sidebar: true,
					},
					component: () => import("./views/website/details.vue"),
				},
				{
					path: "/tasks-dashboard",
					meta: {
						title: "Tasks Dashboard",
						sidebar: true,
						dataRequired: true
					},
					component: () => import("bh-mod/components/layout/TopBar/TasksDashboard/allTasks.vue"),
				},
				{
					path: "/notifications",
					meta: {
						title: "All Notifications",
						sidebar: true,
						dataRequired: true
					},
					component: () => import('bh-mod/components/layout/TopBar/Notifications/notifications.vue'),
				},
			],
		},
		{
			path: "/setup",
			component: Splash,
			meta: { hidden: true, splash: true },
			children: [
				{
					path: "/setup",
					meta: {
						title: "Setup Inventory App",
						splashScreen: true,
					},
					component: () => import("./views/setup"),
				},
			],
		},
		{
			path: '/404',
			component: Splash,
			children: [
				{
					path: '/404',
					meta: {
						title: 'Error 404',
					},
					component: () => import('bh-mod/components/common/404.vue'),
				}
			]
		},
		{
			path: '/unauthorized',
			component: AuthLayout,
			children: [
				{
					path: '/unauthorized',
					meta: {
						title: 'Unauthorized',
						unauthorized: true
					},
					component: () => import('bh-mod/components/common/unauthorized.vue'),
				}
			]
		},
		// Other routes...
		{
			// Catch-all route: This will match any invalid route
			path: '*',
			redirect: '/404'
		}
	],
});

let hiveRequested = false;
let isEmailMonitoringApiSetup = false;
router.beforeEach(async (to, from, next) => {
	let dataRequired = to.matched.some((record) => record.meta.dataRequired);
	let splashScreen = to.matched.some((record) => record.meta.splashScreen);
	let highriseOnly = to.matched.some((record) => record.meta.highriseOnly);
	let unauthorized = to.matched.some(record => record.meta.unauthorized)
	let error = false

	if (!hiveRequested) {
		let response = await VueAppMiddleware(to, store, 'reports')
		error = response.parsed
		hiveRequested = true;
	}

	if (!isEmailMonitoringApiSetup) {
		setupEmailMonitoringApi()
		isEmailMonitoringApiSetup = true
	}

	if (error) {
		if (error === 'User does not have required permission!') {
			return next('/unauthorized')
		}
		return console.error('ERROR', error)
	} else {
		if (unauthorized) {
			return next();
		}
		if (to.path === '/ai' && !store.getters.isAIEnabled) {
			return next('/unauthorized');
		}
		if (highriseOnly && store.state.instance.productType !== "highrise") {
			finalRouter(to, next);
		}
		const showIntro = store.state.theApp?.media?.options?.showIntro;
		const seenIntro = store.state.appData.allSettings?.userApp?.options?.seenIntro;

		if (splashScreen) {
			if (!showIntro) {
				finalRouter(to, next);
			}
			if (seenIntro) {
				finalRouter(to, next);
			}
		}
		if (dataRequired) {
			if (showIntro && !store.state.appData.getStarted && !seenIntro) {
				return next("/setup");
			}
		}
	}
	store.commit("PAGE_BUTTONS", []);

	finalRouter(to, next);
});

const minAccessRoutes = ["/lead", "/pipeline", "/sales"];
const medAccessRouters = ["/email", "/sms", "/ai", "/lead", "/pipeline", "/sales", "/survey", "/worksheet"];

function finalRouter(to, next) {
	if (to.path.startsWith("/setup")) {
		return next();
	}
	if (to.path.startsWith("/agentCommission") && !store.getters?.isWorksheetActive) {
		// restricted reservations page to highrise premium package and active worksheet feature only
		return next("/");
	}
	if (
		store.state.$p <= 10 &&
		!minAccessRoutes.some((path) => to.path.startsWith(path))
	) {
		return next("/lead");
	} else if (
		store.state.$p <= 20 &&
		!medAccessRouters.some((path) => to.path.startsWith(path))
	) {
		return next("/email");
	} else if (store.state.instance?.package?.itemCode === 'PA-COM-LRS' && ['/website', '/survey'].some((path) => to.path.startsWith(path))) {
		return next("/email");
	}
	return next();
}

export default router;
